import { WizardStepIndicator, WizardStepDef } from "@/components/ui/wizard-step-indicator";

export type ApplicationWizardStep = "select" | "assignment" | "configuration" | "pppc";

const ALL_STEPS: WizardStepDef[] = [
  { id: "select", name: "Select App", description: "Choose an application" },
  { id: "assignment", name: "Assignment", description: "Assign to customers" },
  { id: "configuration", name: "Configuration", description: "Add app configuration" },
  { id: "pppc", name: "Privacy (PPPC)", description: "Approve macOS privacy services" },
];

interface ApplicationWizardStepsProps {
  currentStep: ApplicationWizardStep;
  completedSteps: ApplicationWizardStep[];
  /** When false, the PPPC step is hidden (e.g. for iOS apps). */
  showPppcStep?: boolean;
}

export const ApplicationWizardSteps = ({
  currentStep,
  completedSteps,
  showPppcStep = false,
}: ApplicationWizardStepsProps) => {
  const steps = showPppcStep ? ALL_STEPS : ALL_STEPS.filter((s) => s.id !== "pppc");
  return <WizardStepIndicator steps={steps} currentStep={currentStep} completedSteps={completedSteps} />;
};
